<p-dialog [(visible)]="display" [modal]="true" (onHide)="closeDialog()">
	<p-header>
	  <h2>{{'fs.res.finance.researchContract_publication.addFundingProgram' | hisUi}}</h2>
	</p-header>

    <res-external-organization-edit
        [organizations]="getOrganizations()"
        [newResearchPartner]="newResearchPartner"
        [ddKey]="'fs.res.finance.researchContract_publication.budgetSource.researchPartner'"
        [isAddOrganization]="isAddOrganization"
        [showCreateLink]="true"
        [singleSelect]="true"
        (selectedExternalOrgUnitChange)="externalOrganizationsChange($event)"
	    (deleteExternalOrgUnitChange)="deleteOrganizationChange($event)"
	    (createExternalOrgUnitChange)="createExternalOrgUnitChange()">
    </res-external-organization-edit>

    <his-plam>
        <input #content [(ngModel)]="currentContract.externalReferenceNumber" pInputTexst class="inputWidth100" [hisDdKey]="'fs.res.finance.researchContract_publication.externalReferenceNumber'">
    </his-plam>
    <p-footer>
		<button (click)="confirmDialog()">{{'common.apply'|hisUi}}</button>
		<button (click)="closeDialog()">{{'common.cancel'|hisUi}}</button>
	</p-footer>
</p-dialog>

<res-external-organization-create-dialog *ngIf="createOrganizationDialogVisible" [(visibility)]="createOrganizationDialogVisible"
	(saveDialogChange)="saveCreateOrganizationDialogChange($event)">
</res-external-organization-create-dialog>
